export default __webpack_public_path__ + "static/media/esf-cisoo.cc938d89.png";